import { render, staticRenderFns } from "./badminton2016.vue?vue&type=template&id=c3ca6242&"
import script from "./badminton2016.vue?vue&type=script&lang=js&"
export * from "./badminton2016.vue?vue&type=script&lang=js&"
import style0 from "./badminton2016.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports